import decode from 'jwt-decode'
import auth0 from 'auth0-js'

const ID_TOKEN_KEY = 'id_token'
const ACCESS_TOKEN_KEY = 'access_token'
const SHOP_DOMAIN = 'shop_domain'
const SHOP_SETTINGS = 'shop_settings'
const SETUP_INTEGRATION = 'setup_integration'
const CLIENT_ID = 'UPU7nZvSS71o5oGhIPo81YsISMz8OK7h'
const CLIENT_DOMAIN = 'seemore.auth0.com'
const SCOPE = 'openid email profile read:all'
const AUDIENCE = 'https://app.iseemore.io'
const AUTH_USERS = process.env.AUTH_USERS

var auth = new auth0.WebAuth({
  clientID: CLIENT_ID,
  domain: CLIENT_DOMAIN
})

export function login () {
  let hostname = window.location.hostname
  if (window.location.port !== '') {
    hostname = `${hostname}:${window.location.port}`
  }

  if (AUTH_USERS) {
    auth.authorize({
      responseType: 'token id_token',
      redirectUri: `${window.location.protocol}//${hostname}/callback`,
      audience: AUDIENCE,
      scope: SCOPE
    })
  } else {
    const domain = getUrlParameter('shop')
    window.location.href = `${process.env.API_URL}platforms/shopify/authorize/${domain}`
  }
}

export function logout () {
  clearIdToken()
  clearAccessToken()
  login()
}

export function requireAuth (to, from, next) {
  if (process.env.DEFAULT_SHOP_DOMAIN) {
    setShopDomain(process.env.DEFAULT_SHOP_DOMAIN)
    localStorage.setItem(ACCESS_TOKEN_KEY, 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhbHR2aWV3QHRoaW5rcGl2b3QuaW8iLCJuYW1lIjoiYWx0IFZpZXciLCJlbWFpbCI6ImFsdHZpZXdAdGhpbmtwaXZvdC5pbyIsImlhdCI6MTUxNjIzOTAyMn0.dW5jTrP-OK7XoEU2DAyeMIc6B_Ps3VRUUwzoPvDmFmM')
    next()
  } else {
    if (!isLoggedIn() || !getShopDomain()) {
      const hasShareId = !!to.query.share

      if (!hasShareId) {
        login()
      } else {
        setShopDomain(to.query.domain)
        next()
      }
    } else {
      next()
    }
  }
}

export function getIdToken () {
  let token = localStorage.getItem(ID_TOKEN_KEY)
  if (token === 'null') {
    return null
  }
  return token
}

export function getAccessToken () {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

function clearIdToken () {
  localStorage.removeItem(ID_TOKEN_KEY)
}

function clearAccessToken () {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}

export function getShopDomain () {
  return localStorage.getItem(SHOP_DOMAIN)
}

export function setShopDomain (domain) {
  localStorage.setItem(SHOP_DOMAIN, domain)
}

export function setCallbackShopDomain () {
  let domain = getParameterByName('shop')
  if (domain) {
    localStorage.setItem(SHOP_DOMAIN, domain)
  }
}

export function getShopSettings () {
  return JSON.parse(localStorage.getItem(SHOP_SETTINGS))
}

export function setSetupIntegration (settings) {
  localStorage.setItem(SETUP_INTEGRATION, JSON.stringify(settings))
}

export function getSetupIntegration () {
  return JSON.parse(localStorage.getItem(SETUP_INTEGRATION))
}

export function setShopSettings (settings) {
  localStorage.setItem(SHOP_SETTINGS, JSON.stringify(settings))
}

function getUrlParameter (name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  var results = regex.exec(location.search)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName (name) {
  let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash)
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
}

// Get and store access_token in local storage
export function setAccessToken () {
  let accessToken = getParameterByName('access_token')
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
}

// Get and store id_token in local storage
export function setIdToken () {
  let idToken = getParameterByName('id_token')
  localStorage.setItem(ID_TOKEN_KEY, idToken)
}

export function isLoggedIn () {
  let idToken = getAccessToken()

  if (AUTH_USERS) {
    idToken = getIdToken()
  }

  return !!idToken && !isTokenExpired(idToken)
}

export function getProfile () {
  let idToken = getAccessToken()

  if (AUTH_USERS) {
    idToken = getIdToken()
  }

  let profile = idToken ? decode(idToken) : null
  if (!profile || !profile.name) {
    return null
  }
  return profile
}

function getTokenExpirationDate (encodedToken) {
  let token = decode(encodedToken)
  if (!token.exp) {
    return null
  }

  let date = new Date(0)
  date.setUTCSeconds(token.exp)

  return date
}

function isTokenExpired (token) {
  let expirationDate = getTokenExpirationDate(token)
  return expirationDate < new Date()
}



// WEBPACK FOOTER //
// ./src/js/utils/auth.js